import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  &:last-child {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Box, Button as CoreButton } from "@miro-site/core";
var List = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        as: "ul",
        $styles: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto"
        }
    };
}).withConfig({
    componentId: "sc-934d1ba3-0"
})(_templateObject());
List.displayName = "CtaNavigation.List";
var ListItem = styled.li.withConfig({
    componentId: "sc-934d1ba3-1"
})(_templateObject1(), function(props) {
    return props.theme.normalizeStyles({
        marginRight: props.theme.header.ctaNavigation.gutter
    });
});
ListItem.displayName = "CtaNavigation.ListItem";
var Button = styled(CoreButton).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "needReferer"
        ].includes(prop);
    }
}).attrs(function(param) {
    var theme = param.theme, $isMobileButton = param.$isMobileButton, _needReferer = param.needReferer, needReferer = _needReferer === void 0 ? false : _needReferer, _$typeOfButton = param.$typeOfButton, $typeOfButton = _$typeOfButton === void 0 ? "" : _$typeOfButton;
    return {
        rel: needReferer ? "strict-origin-when-cross-origin" : "no-referrer",
        $buttonType: $typeOfButton ? $typeOfButton : $isMobileButton ? theme.header.ctaNavigation.mobileButton.type : theme.header.ctaNavigation.button.type,
        $withArrow: true,
        $styles: $isMobileButton ? _object_spread_props(_object_spread({}, theme.header.ctaNavigation.mobileButton.size), {
            ".focus-trap": _object_spread({}, theme.header.ctaNavigation.mobileButton.spacing)
        }) : _object_spread_props(_object_spread({
            display: "block"
        }, theme.header.ctaNavigation.button.size), {
            ".focus-trap": _object_spread({}, theme.header.ctaNavigation.button.spacing)
        })
    };
}).withConfig({
    componentId: "sc-934d1ba3-2"
})(_templateObject2());
var CtaNavigation = function(props) {
    return /*#__PURE__*/ _jsx(List, {
        "data-track-place": "Header",
        children: React.Children.map(props.children, function(c, i) {
            return /*#__PURE__*/ _jsx(ListItem, {
                children: c
            }, i);
        })
    });
};
export default Object.assign(CtaNavigation, {
    Button: Button
});
